/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import { createAgent } from '@vlinder-web/plugin-agent-service-react';
import {
  HeaderService,
  IHeaderMethods,
  IStaticPageContentMethods,
  StaticPageContentService,
  ILoadingMethods,
  LoadingService,
  ICreateBatchSerializationMethods,
  CreateBatchSerializationService,
} from './components';

export type NewBatchSerializationPageAgent = IHeaderMethods &
  IStaticPageContentMethods &
  ILoadingMethods &
  ICreateBatchSerializationMethods;

const getPlugins = () => {
  return [
    new HeaderService(),
    new CreateBatchSerializationService(),
    new StaticPageContentService(),
    new LoadingService(),
  ];
};

export const getAgent = () => {
  return createAgent<NewBatchSerializationPageAgent>({
    plugins: getPlugins(),
  });
};
